import React from 'react'
import api from '..'
import { toast } from 'react-toastify'
import i18n from 'i18next'
import ToastBody from 'components/ui/toast/ToastBody'
import {
  faCheckCircle,
  faTimesCircle,
  faCloudUploadAlt,
} from '@fortawesome/pro-solid-svg-icons'
import IUploadFileMessageProps from '../../interfaces/upload-file-message-props'

const defaultMessages = {
  uploading: 'commons.upload.uploading',
  success: 'commons.upload.success',
  error: 'commons.upload.error',
} as const

const UploadFile = <T,>(
  file: File,
  url: string,
  messages?: IUploadFileMessageProps
) => {
  let toastId: any = null

  const formData = new FormData()
  formData.append('attachment[file]', file)

  return api
    .post<T>(url, formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
      onUploadProgress: (p) => {
        const progress = p.loaded / p.total
        if (toastId === null) {
          toastId = toast(
            <ToastBody
              icon={faCloudUploadAlt}
              text={
                <>
                  {messages?.uploading || i18n.t(defaultMessages.uploading)}
                  &nbsp;
                  {file.name}
                </>
              }
            />,
            {
              autoClose: false,
              progress: progress,
            }
          )
        } else {
          toast.update(toastId, {
            progress: progress,
          })
        }
      },
    })
    .then(
      (response) => {
        toast.dismiss(toastId)
        toast(
          <ToastBody
            icon={faCheckCircle}
            text={messages?.success || i18n.t(defaultMessages.success)}
          />,
          {
            type: toast.TYPE.SUCCESS,
          }
        )
        return response
      },
      (response) => {
        toast.dismiss(toastId)
        toast(
          <ToastBody
            icon={faTimesCircle}
            text={
              <>
                {messages?.error || i18n.t(defaultMessages.error)}
                &nbsp;
                {file.name}
              </>
            }
          />,
          {
            type: toast.TYPE.ERROR,
          }
        )
        throw response
      }
    )
}

export default UploadFile
